//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "TopicHeader",
  created() {},
  props: ["topic"],
  data() {
    return {
      showFullDesc: false
    };
  },
  methods: {}
};



// WEBPACK FOOTER //
// ./src/components/topic/TopicHeader.vue